<div class="container my-5">

    <header class="text-center mb-5">
        <h1 class="display-4">We're Hiring: Front-End Engineer</h1>
        <p class="lead">Join our team and help us create amazing web experiences!</p>
    </header>

    <section class="mb-5">
        <h2>About the Role</h2>
        <p>
            We are looking for a talented and passionate <strong>Front-End Engineer</strong> to join our dynamic team.
            You will play a key role in designing and building intuitive, user-friendly interfaces that provide an
            exceptional
            user experience for our customers.
        </p>
    </section>

    <section class="mb-5">
        <h2>Responsibilities</h2>
        <ul>
            <li>Develop, test, and maintain high-quality web interfaces using modern frameworks.</li>
            <li>Collaborate with designers, product managers, and back-end developers to implement features.</li>
            <li>Ensure the technical feasibility of UI/UX designs.</li>
            <li>Optimize applications for speed and scalability.</li>
            <li>Write clean, maintainable, and reusable code.</li>
            <li>Stay updated with the latest front-end trends and technologies.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Qualifications</h2>
        <ul>
            <li>Proven experience as a Front-End Engineer or similar role.</li>
            <li>Proficiency in HTML5, CSS3, JavaScript, and modern frameworks like React, Angular, or Vue.js.</li>
            <li>Experience with responsive and adaptive design principles.</li>
            <li>Familiarity with version control systems like Git.</li>
            <li>Understanding of SEO principles and cross-browser compatibility.</li>
            <li>Strong problem-solving skills and attention to detail.</li>
            <li>Excellent communication and collaboration abilities.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Nice-to-Haves</h2>
        <ul>
            <li>Experience with TypeScript or Webpack.</li>
            <li>Knowledge of testing frameworks like Jest or Cypress.</li>
            <li>Familiarity with Figma or other design tools.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Benefits</h2>
        <ul>
            <li>Competitive salary and performance-based bonuses.</li>
            <li>Comprehensive health, dental, and vision insurance.</li>
            <li>Flexible working hours and remote work options.</li>
            <li>Professional development opportunities and training budget.</li>
            <li>Collaborative and inclusive work culture.</li>
        </ul>
    </section>

    <!-- <section class="text-center">
        <h2>How to Apply</h2>
        <p>
            Interested? Send your resume and portfolio to <a
                href="mailto:careers@yourcompany.com">careers@yourcompany.com</a>.
            Make sure to include a cover letter explaining why you're the perfect fit for this role.
        </p>
        <a href="mailto:careers@nordnative.com" class="btn btn-primary btn-lg">Apply Now</a>
    </section> -->
</div>
